module.exports = __webpack_public_path__ + "img/item16.359fcc45.png";